class CartDrawer extends HTMLElement {
  constructor() {
    super();
    this.addEventListener("keyup", (evt) => evt.code === "Escape" && this.close());
    this.querySelector("#CartDrawer-Overlay").addEventListener("click", this.close.bind(this));
    this.setHeaderCartIconAccessibility();
  }

  connectedCallback() {
    const cartDrawerSection = document.querySelector(".cart-drawer-section");
    const shopifySection = JSON.parse(cartDrawerSection.getAttribute("data-shopify-editor-section"));
    document.addEventListener("shopify:section:select", function (event) {
      if (event.detail.sectionId === shopifySection.id) {
        console.log("Cart Drawer section selected.");
        setTimeout(() => {
          this.classList.add("animate", "active");
        });
      }
    });

    document.addEventListener("shopify:section:deselect", function (event) {
      if (event.detail.sectionId === shopifySection.id) {
        console.log("Cart Drawer section deselected.");
        this.close();
      }
    });
  }

  setHeaderCartIconAccessibility() {
    const cartLinks = document.querySelectorAll("#cart-icon-bubble");
    console.log("cartLinks", cartLinks);
    cartLinks.forEach((cartLink) => {
      cartLink.setAttribute("role", "button");
      cartLink.setAttribute("aria-haspopup", "dialog");
      cartLink.addEventListener("click", (event) => {
        event.preventDefault();
        this.open(cartLink);
        cartLink.addEventListener("keydown", (event) => {
          if (event.code.toUpperCase() === "SPACE") {
            event.preventDefault();
            this.open(cartLink);
          }
        });
      });
    });
  }

  open(triggeredBy) {
    console.log("open");
    if (triggeredBy) this.setActiveElement(triggeredBy);
    const cartDrawerNote = this.querySelector('[id^="Details-"] summary');
    if (cartDrawerNote && !cartDrawerNote.hasAttribute("role")) this.setSummaryAccessibility(cartDrawerNote);
    // here the animation doesn't seem to always get triggered. A timeout seem to help
    setTimeout(() => {
      this.classList.add("animate", "active");
    });

    this.addEventListener(
      "transitionend",
      () => {
        // Vérifier si le panier est vide AVANT de chercher les éléments
        const isEmpty = this.classList.contains("is-empty");
        let containerToTrapFocusOn = isEmpty
          ? this.querySelector(".drawer__inner-empty")
          : document.getElementById("CartDrawer");

        // Fallback si l'élément n'existe pas (peut arriver si le HTML n'est pas encore à jour)
        if (!containerToTrapFocusOn) {
          containerToTrapFocusOn = this.querySelector(".drawer__inner") || document.getElementById("CartDrawer") || this;
        }

        const focusElement = this.querySelector(".drawer__inner") || this.querySelector(".drawer__close");

        // Ne pas appeler trapFocus si le conteneur n'existe toujours pas
        if (containerToTrapFocusOn && focusElement) {
          trapFocus(containerToTrapFocusOn, focusElement);
        }
      },
      { once: true }
    );
    const reward_price_block = document.querySelector(".tr-price-reward");
    if (reward_price_block) {
      reward_price_block.style.width = document.oldRewardPercentage + "%";
      const percent_price = 100 - reward_price_block.dataset.reward;
      setTimeout(() => {
        reward_price_block.style.width = percent_price + "%";
      }, 500);
      document.oldRewardPercentage = percent_price;
    }
    document.body.classList.add("overflow-hidden");
  }

  close() {
    console.log("close");
    this.classList.remove("active");
    removeTrapFocus(this.activeElement);
    document.body.classList.remove("overflow-hidden");
  }

  setSummaryAccessibility(cartDrawerNote) {
    cartDrawerNote.setAttribute("role", "button");
    cartDrawerNote.setAttribute("aria-expanded", "false");

    if (cartDrawerNote.nextElementSibling.getAttribute("id")) {
      cartDrawerNote.setAttribute("aria-controls", cartDrawerNote.nextElementSibling.id);
    }

    cartDrawerNote.addEventListener("click", (event) => {
      event.currentTarget.setAttribute("aria-expanded", !event.currentTarget.closest("details").hasAttribute("open"));
    });

    cartDrawerNote.parentElement.addEventListener("keyup", onKeyUpEscape);
  }

  renderContents(parsedState) {
    const oldItemCount = this.querySelector(".drawer__heading")?.dataset.itemCount || 0;
    let jollyModalProduct = document.querySelector("jolly-modal-product");

    // Ne pas gérer is-empty ici car item_count n'existe pas dans la réponse de /cart/add.js
    // On le gérera après avoir rendu les sections en vérifiant le contenu HTML

    this.productId = parsedState.id;
    console.log("this.getSectionsToRender()", this.getSectionsToRender());
    this.getSectionsToRender().forEach((section) => {
      const sectionElement = section.selector ? document.querySelector(section.selector) : document.getElementById(section.id);

      // Vérifier que la section existe dans la réponse avant de continuer
      if (!parsedState.sections || !parsedState.sections[section.id]) {
        console.warn(`Section ${section.id} non trouvée dans la réponse du serveur`);
        return;
      }

      // Vérifier que l'élément DOM existe avant de le mettre à jour
      if (!sectionElement) {
        console.warn(`Élément DOM non trouvé pour la section ${section.id} avec le sélecteur ${section.selector || section.id}`);
        return;
      }

      let html = this.getSectionInnerHTML(parsedState.sections[section.id], section.selector);

      // Si getSectionInnerHTML retourne une chaîne vide, ne pas mettre à jour
      if (!html) {
        return;
      }

      const domparser = new DOMParser();
      const cartDom = domparser.parseFromString(html, "text/html");

      console.log(sectionElement);
      /* const old_reward_price_block = cartDom.querySelector(".tr-price-reward");
      if (old_reward_price_block) {
        old_reward_price_block.style.width = document.oldRewardPercentage + "%";
      } */
      sectionElement.innerHTML = cartDom.documentElement.innerHTML;
    });

    // Après avoir rendu les sections, vérifier si le panier est vide en regardant le contenu HTML
    // Vérifier si cart-drawer-items contient des items
    const cartDrawerItems = this.querySelector(".cart-drawer-items");
    const hasItems = cartDrawerItems && (
      cartDrawerItems.querySelector(".cart-item") ||
      cartDrawerItems.querySelector('[id^="CartDrawer-Item-"]') ||
      !cartDrawerItems.classList.contains("is-empty")
    );

    // Gérer la classe is-empty sur le cart-drawer lui-même
    if (hasItems) {
      this.classList.remove("is-empty");
      // Retirer aussi is-empty de drawer__inner si présent
      const drawerInner = this.querySelector(".drawer__inner");
      if (drawerInner && drawerInner.classList.contains("is-empty")) {
        drawerInner.classList.remove("is-empty");
      }
    } else {
      // Si pas d'items, vérifier aussi dans les sections HTML retournées
      const cartDrawerItemsSection = parsedState.sections?.["cart-drawer-items"];
      if (cartDrawerItemsSection) {
        const tempDom = new DOMParser().parseFromString(cartDrawerItemsSection, "text/html");
        const hasItemsInSection = tempDom.querySelector(".cart-item") ||
                                  tempDom.querySelector('[id^="CartDrawer-Item-"]') ||
                                  !tempDom.querySelector(".is-empty");

        if (hasItemsInSection) {
          this.classList.remove("is-empty");
          const drawerInner = this.querySelector(".drawer__inner");
          if (drawerInner && drawerInner.classList.contains("is-empty")) {
            drawerInner.classList.remove("is-empty");
          }
        } else {
          this.classList.add("is-empty");
        }
      }
    }

    const newItemCount = this.querySelector(".drawer__heading")?.dataset.itemCount || 0;

    if (newItemCount - oldItemCount > 0) {
      //this.querySelector('.drawer__heading .jc-item-count').innerText = `${newItemCount - oldItemCount}`;
      const drawerHeader = this.querySelector(".drawer__header");
      const drawerHeading = this.querySelector(".drawer__heading");
      if (drawerHeader && drawerHeading) {
        drawerHeader.style.height = "60px";
        drawerHeading.style.top = "20px";
        setTimeout(() => {
          drawerHeader.style.height = "0px";
          drawerHeading.style.top = "-35px";
        }, 3000);
      }
    }

    setTimeout(() => {
      const overlay = this.querySelector("#CartDrawer-Overlay");
      if (overlay) {
        overlay.addEventListener("click", this.close.bind(this));
      }
      document.dispatchEvent(new CustomEvent("tr-cart:reload"));

      const cartDrawer = this.querySelector(".cart-drawer");
      if (cartDrawer && cartDrawer.dataset.openCart == "true") {
        this.open();
      }

      if (jollyModalProduct) {
        jollyModalProduct.classList.remove("jc-translate-y-0");
        jollyModalProduct.classList.add("jc-translate-y-full");
      }

      const modalShadow = document.getElementById("jc-modal-shadow");
      if (modalShadow) {
        modalShadow.classList.add("jc-hidden");
      }
    });
  }

  getSectionInnerHTML(html, selector = ".shopify-section") {
    const parsed = new DOMParser().parseFromString(html, "text/html");
    const element = parsed.querySelector(selector);
    // Vérifier que l'élément existe avant d'accéder à innerHTML
    if (!element) {
      console.warn(`Élément non trouvé avec le sélecteur: ${selector}`);
      return '';
    }
    return element.innerHTML;
  }

  getSectionsToRender() {
    return [
      {
        id: "cart-drawer-items",
        section: "cart-drawer-items",
        selector: ".cart-drawer-items",
      },
      {
        id: "cart-drawer-reward",
        section: "cart-drawer-reward",
        selector: ".cart-drawer-reward",
      },
      {
        id: "cart-icon-bubble",
        section: "cart-icon-bubble",
        selector: ".cart-count-bubble",
      },
      {
        id: "cart-drawer-footer",
        section: "cart-drawer-footer",
        selector: ".drawer__footer",
      },
      {
        id: "cart-upsell-recommendation",
        section: "cart-upsell-recommendation",
        selector: ".cart-upsell-recommendation",
      },
    ];
  }

  getSectionDOM(html, selector = ".shopify-section") {
    return new DOMParser().parseFromString(html, "text/html").querySelector(selector);
  }

  setActiveElement(element) {
    this.activeElement = element;
  }
}

customElements.define("cart-drawer", CartDrawer);

class CartDrawerItems extends CartItems {
  getSectionsToRender() {
    return [
      {
        id: "cart-drawer-items",
        section: "cart-drawer-items",
        selector: ".shopify-section",
      },
      {
        id: "cart-drawer-reward",
        section: "cart-drawer-reward",
        selector: ".shopify-section",
      },
      {
        id: "cart-icon-bubble",
        section: "cart-icon-bubble",
        selector: ".cart-count-bubble",
      },
      {
        id: "cart-drawer-footer",
        section: "cart-drawer-footer",
        selector: ".drawer__footer",
      },
      {
        id: "cart-upsell-recommendation",
        section: "cart-upsell-recommendation",
        selector: ".cart-upsell-recommendation",
      },
    ];
  }
}

customElements.define("cart-drawer-items", CartDrawerItems);
